import { Button, makeStyles } from 'vendor/material';
import type { TeamType } from './sectionSchema';
import { TrashCan } from 'mdi-material-ui';
import { fontWeightMediumLarge } from 'utils/fontWeightConstants';
import { useReferralFormContext } from '../ReferralFormContext';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingBlock: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.NEUTRAL030}`,
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: 'repeat(3, 1fr) auto',
  },
  detail: {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gap: theme.spacing(0.5),
    justifyContent: 'start',
    alignItems: 'start',
    margin: 0,
  },
  detailValue: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(24),
    color: theme.palette.NEUTRAL500,
    margin: 0,
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
  detailLabel: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: fontWeightMediumLarge,
    lineHeight: theme.typography.pxToRem(20),
    color: theme.palette.NEUTRAL300,
    margin: 0,
  },
  iconButton: {
    height: 'max-content',
    alignSelf: 'start',
    justifySelf: 'flex-end',
    width: 'content',
    margin: '0 !important',
    transform: 'translateY(1rem)',
  },
}));

const MemberListItem = ({
  fieldName,
  member,
  onDelete,
}: {
  fieldName: string;
  member: TeamType[number];
  onDelete: () => void;
}) => {
  const { register } = useReferralFormContext();
  const classes = useStyles();
  const hiddenInputs = Object.entries(member).map(([name, value]) => {
    const fullFieldName = `${fieldName}.${name}`;
    return (
      <input
        key={fullFieldName}
        type="hidden"
        ref={register()}
        name={fullFieldName}
        value={value}
      />
    );
  });

  const details = [
    { label: 'Name', value: `${member.firstName} ${member.lastName}` },
    { label: 'Email', value: member.email },
    { label: 'Phone', value: member.phoneNumber },
  ];

  return (
    <div className={classes.wrapper}>
      {hiddenInputs}

      {details.map(({ label, value }, i) => (
        <dl className={classes.detail} key={label}>
          <dt className={classes.detailLabel}>{label}</dt>
          <dd className={classes.detailValue}>{value}</dd>
        </dl>
      ))}

      <Button
        aria-label="Remove member"
        className={classes.iconButton}
        variant="text"
        onClick={onDelete}
      >
        <TrashCan />
      </Button>
    </div>
  );
};

export default MemberListItem;
